import { useState } from "react"
import { Helmet } from "react-helmet-async"
import { IntegrationItem } from "./../../../../Integrations"
import { Navigate, useLocation, useParams } from "../../../../router-utils"

export default function IntegrationItemDetailsPage() {
	const location = useLocation()
	const { integrationId } = useParams("/integrations/:integrationId")
	const [lastCreatedToken, setLastCreatedToken] = useState<string | undefined>(
		typeof location.state === "string" ? location.state : undefined
	)
	return (
		<>
			<Helmet>
				<title>Integration Details</title>
			</Helmet>
			<IntegrationItem
				lastCreatedToken={lastCreatedToken}
				integrationId={integrationId}
				setLastCreatedToken={setLastCreatedToken}
			>
				{({ integration }) =>
					integration.platform === "pg_payu" ||
					integration.platform === "pg_simulator" ? (
						<Navigate
							to={"/integrations/:integrationId/pg"}
							params={{ integrationId }}
							replace
						/>
					) : integration.platform === "whatsapp_cloud_api" ||
					  integration.platform === "whatsapp_simulator" ? (
						<Navigate
							to={"/integrations/:integrationId/whatsapp"}
							params={{ integrationId }}
							replace
						/>
					) : integration.platform === "email_mailbox" ? (
						<Navigate
							to={"/integrations/:integrationId/mail"}
							params={{ integrationId }}
							replace
						/>
					) : null
				}
			</IntegrationItem>
		</>
	)
}
